import React, { useState, useEffect, useMemo } from 'react'
import { Button, Input } from 'antd';

const { TextArea } = Input;

import './index.less';

interface QuestionInputProps {
  inputValue: string;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
  defaultValue?: string;
  onSend: (question: string) => void;
  isLoading?: boolean;
  maxLength?: number;
  placeholder?: string;
  defaultDisplayContent?: string;
}

export default function QuestionInput(props: QuestionInputProps) {

  const inputRef = React.useRef<HTMLTextAreaElement>(null);

  const { 
    inputValue,
    setInputValue, 
    onSend,
    isLoading = false,
    maxLength,
    placeholder,
    defaultDisplayContent
  } = props;
  // const [value, setValue] = useState("");

  const isDisable = useMemo(() => {
    return isLoading; // || inputValue.trim().length === 0
  }, [isLoading, inputValue]);

  const onClickSend = () => {
    if (isDisable) return;
    onSend(inputValue.trim() || (placeholder || ""));
  }
  const onEnterKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      onClickSend();
    }
  }

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  

  return (
    <div className="question-input">
      <TextArea
        ref={inputRef}
        className='question-input__textarea'
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder={placeholder ? placeholder : defaultDisplayContent ? defaultDisplayContent : `问我任何问题${maxLength ? `，最多输入${maxLength}字` : ''}`}
        autoSize={{ minRows: 3, maxRows: 5 }}
        variant="borderless"
        onPressEnter={onEnterKeyDown}
        maxLength={maxLength}
        showCount={maxLength ? true : false}
        styles={{
          count: {
            color: "#949494"
          }
        }}
      />
      <div className="question-input__actions">
        <div className={`question-input__actions-send ${isDisable ? "send-disabled" : ""}`} onClick={onClickSend}></div>
        {/* <Button onClick={() => onSend(inputValue)} disabled={isLoading}>发送</Button> */}
      </div>
      {/* <div > */}
        <div className="question-input__copyright">Powered by Kaihong Super Agent</div>
      {/* </div> */}
  </div>
  )
}
